<template>
  <b-card class="mb-2">
    <b-form class="mt-3" @submit="onSubmitForm">
      <b-row>
        <!-- TEST DATE -->
        <!-- <b-col cols="12" md="3" >
              <InputFilter :filter="search[0]"/>
            </b-col>
            <b-col cols="12" md="3" >
              <InputFilter :filter="search[0]"/>
            </b-col> -->
        <!-- TEST DATE -->
        <!-- TEST TIME -->
        <!-- <b-col cols="12" md="3" >
              <InputFilter :filter="search[0]"/>
            </b-col>
            <b-col cols="12" md="3" >
              <InputFilter :filter="search[0]"/>
            </b-col> -->
        <!-- TEST TIME -->

        <b-col cols="12" md="6">
          <InputFilter :filter="search[0]" />
        </b-col>
        <b-col cols="12" md="6">
          <InputFilter :filter="search[1]" />
        </b-col>

        <b-col cols="12" md="6">
          <InputFilter :filter="search[2]" />
        </b-col>
        <b-col cols="12" md="3">
          <InputFilter :filter="search[3]" />
        </b-col>
        <b-col cols="12" md="3">
          <InputFilter :filter="search[4]" />
        </b-col>
        <!-- TEST SELECT -->
        <!-- <b-col cols="12" md="6" >
              <InputFilter :filter="search[5]"/>
            </b-col> -->
        <!-- TEST SELECT -->
      </b-row>
      <!-- Action Buttons -->
      <div class="text-center pt-1">
        <b-button
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          type="submit"
          @click="onSearchBtnClicked"
        >
          ค้นหา
        </b-button>
        <b-button
          variant="outline-secondary"
          type="reset"
          @click="onResetBtnClicked"
        >
          ล้าง
        </b-button>
      </div>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BCard,
  BCardHeader,
  BCardBody,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import InputFilter from "./components/InputFilter.vue";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BCard,
    BCardHeader,
    BCardBody,
    BFormCheckbox,
    vSelect,
    InputFilter,
  },
  //    props: {
  //      searchModel: {
  //        type: Object,
  //        required: false,
  //      },
  //    },
  setup(props) {
    const options = [
      { label: "Admin", value: "1" },
      { label: "Author", value: "2" },
      { label: "Editor", value: "3" },
      { label: "Maintainer", value: "4" },
      { label: "Subscriber", value: "5" },
    ];

    const search = [
      {
        id: "receiveCode",
        label: "เลขรับแจ้ง / เลขสารบัญ / รหัสติดตามเรื่องหน่วยงานภายนอก",
        value: "",
        class: "",
        style: "",
        placeholder:
          "กรอกเลขรับแจ้ง / เลขสารบัญ / รหัสติดตามเรื่องหน่วยงานภายนอก",
        type: "text",
        options: [],
      },
      {
        id: "attorneySearch",
        label: "ข้อมูลผู้ร้องทุกข์ / ผู้มอบอำนาจ (ชื่อ-นามสกุล/เลขบัตรประชาชน)",
        value: "",
        class: "",
        style: "",
        placeholder: "กรอกข้อมูลผู้ร้องทุกข์ / ผู้มอบอำนาจ",
        type: "text",
        options: [],
      },
      {
        id: "companySearch",
        label:
          "ข้อมูลผู้ถูกร้องทุกข์ / ผู้ประกอบการ  (ชื่อผู้ประกอบการ / เลขนิติบุคคล)",
        value: "",
        class: "",
        style: "",
        placeholder:
          "กรอกข้อมูลผู้ถูกร้องทุกข์ / ผู้ประกอบการ  (ชื่อผู้ประกอบการ / เลขนิติบุคคล)",
        type: "text",
        options: [],
      },
      {
        id: "startdateSearch",
        label: "ช่วงเวลาที่ร้องทุกข์",
        value: "",
        class: "",
        style: "",
        placeholder: "จากวันที่",
        type: "date",
        options: [],
      },
      {
        id: "enddateSearch",
        label: "ถึง",
        value: "",
        class: "",
        style: "",
        placeholder: "ถึงวันที่",
        type: "date",
        options: [],
      },
      {
        id: "testselect",
        label: "ช่วงเวลาที่ร้องทุกข์",
        value: "",
        class: "",
        style: "",
        placeholder: "",
        type: "select",
        options,
      },
    ];
    return {
      options,
      search,
    };
  },
  methods: {
    onSubmitForm(e) {
      e.preventDefault();
      this.onSearchBtnClicked();
    },
    onResetBtnClicked() {
      this.search[0].value = null;
      this.search[1].value = null;
      this.search[2].value = null;
      this.search[3].value = null;
      this.search[4].value = null;
      this.search[5].value = null;
    },

    onSearchBtnClicked() {
      //console.log('props.mode', this.props.mode)

      // if (this.props.mode === 'List') {
      // const params = {
      //     code : this.search[0].value,
      //     name : this.search[1].value,
      //     company : this.search[2].value,
      //     startDate : this.search[3].value,
      //     endDate : this.search[4].value,
      //     value : this.search[5].value,
      //     departmentId : this.search[6].value,
      //     status : this.search[7].value,
      // }

      // //console.log('onSearchBtnClicked', params)

      // this.$emit('handleSubmit', params)

      // }
      // else {
      //   const params = {
      //     code : this.search[0].value,
      //     name : this.search[1].value,
      // }

      // this.$emit('handleSubmit', params)
      // }

      const params = {
        code: this.search[0].value,
        Complaint: this.search[1].value,
        Company: this.search[2].value,
        createdete: this.search[3].value,
        enddate: this.search[4].value,
      };

      this.$emit("handleSubmit", params);
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
